import { QueryClientProvider as RQQueryClientProvider, QueryClientProviderProps as RQQueryClientProviderProps } from '@tanstack/react-query';

import { queryClient } from './query-client';

export function QueryClientProvider(props: Omit<RQQueryClientProviderProps, 'client'>) {
  return <RQQueryClientProvider client={queryClient}>{props.children}</RQQueryClientProvider>;
}
